__webpack_require__.p = "https://static.recollective.com/v1.6.15-006/_inc/dist/";